/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getCurrentWorkingTeamMembersCount} from '../api'

 export const useQueryGetCurrentWorkingTeamMembersCount = createReactQueryHook('getCurrentWorkingTeamMembersCount', getCurrentWorkingTeamMembersCount)
